import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import Link from 'components/Link';
import { SITE_ORIGIN } from 'constants/site';
import { getKickerProps } from 'util/link';

/**
 * Outputs list of links in breadcrumb format
 * Assumes these are tags. If this changes the `as` and `href` values will need
 * to be udpated.
 * Only show one for now
 */
function PostKicker({ tags, whitelist, categories, link }) {
  const { tag, tagLinkProps, category, categoryLinkProps } = getKickerProps(
    tags,
    whitelist,
    categories
  );

  // kicker has been given an a link override
  if (link.as && link.href && link.title) {
    return (
      <div className="Post__kicker">
        <Link href={link.href} as={link.as}>
          <a className="Post__kicker-link Post__kicker-link--tag">
            {link.title}
          </a>
        </Link>
      </div>
    );
  }

  // For older posts that have Sponsored in the category list just dont show the kicker
  if (category && category.slug === 'sponsored')
    return <div className="Post__kicker" />;

  return (
    <div className="Post__kicker">
      {tag !== undefined && (
        <Link {...tagLinkProps}>
          <a className="Post__kicker-link Post__kicker-link--tag">{tag.name}</a>
        </Link>
      )}
      {tag === undefined && category && categoryLinkProps && (
        <Link {...categoryLinkProps}>
          <a
            className="Post__kicker-link Post__kicker-link--category"
            dangerouslySetInnerHTML={{
              __html: category.name
            }}
          />
        </Link>
      )}
      {category && categoryLinkProps && categoryLinkProps.as && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: category.name,
                  item: `${SITE_ORIGIN}${categoryLinkProps.as}`
                }
              ]
            })
          }}
        />
      )}
    </div>
  );
}

PostKicker.propTypes = {
  categories: arrayOf(
    shape({
      name: string,
      slug: string
    })
  ),
  tags: arrayOf(
    shape({
      name: string,
      slug: string
    })
  ),
  whitelist: shape({
    categories: arrayOf(string),
    subtitle: arrayOf(string)
  }),
  link: shape({
    href: string,
    as: string,
    title: string
  })
};

PostKicker.defaultProps = {
  tags: [],
  categories: [],
  whitelist: undefined,
  link: {}
};

export default PostKicker;
